import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";

const useDeviceSizes = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up(1440));
  const isTablet = useMediaQuery(theme.breakpoints.between(720, 1440));
  const isMobile = useMediaQuery(theme.breakpoints.down(720));

  return { isDesktop, isTablet, isMobile };
};

export default useDeviceSizes;
